// extracted by mini-css-extract-plugin
export default {"button":"stylesReviewRulesLink_button__hH5JV","ruleCount":"stylesReviewRulesLink_ruleCount__M7h5S"};